import {createFileRoute} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";
import {getAccessibleWorkspacesWithCaching, getInvitesWorkspacesWithCaching} from "~/utilities/queries";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/u/select-workspace")({
    loader: async ({context}) => {
        const accessibleWorkspacesResult = await getAccessibleWorkspacesWithCaching({
            accessToken: context.authenticationStatus.accessToken,
            queryClient: context.queryClient,
            intellsysBaseUrl: context.intellsysBaseUrl,
        });
        if (accessibleWorkspacesResult.success === false) {
           throw new Error("Failed to get available workspaces");
        }
        const accessibleWorkspaces = accessibleWorkspacesResult.data;

        const invitedworkspacesResult = await getInvitesWorkspacesWithCaching({
            accessToken: context.authenticationStatus.accessToken,
            queryClient: context.queryClient,
            intellsysBaseUrl: context.intellsysBaseUrl,
        });
        if (invitedworkspacesResult.success === false) {
            throw new Error("Failed to get invited workspaces");
        }
        const invitedWorkspaces = invitedworkspacesResult.data;

        return {
            accessibleWorkspaces: accessibleWorkspaces,
            invitedWorkspaces: invitedWorkspaces,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
